/**
 * @generated SignedSource<<1a75ce03392320ebcec598dac6bdc7c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamNavigatorNoTeam_home$data = {
  readonly __typename: "Organisation";
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "TeamNavigatorNoTeam_home";
} | {
  readonly __typename: "Store";
  readonly " $fragmentType": "TeamNavigatorNoTeam_home";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "TeamNavigatorNoTeam_home";
};
export type TeamNavigatorNoTeam_home$key = {
  readonly " $data"?: TeamNavigatorNoTeam_home$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamNavigatorNoTeam_home">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamNavigatorNoTeam_home",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/)
      ],
      "type": "Store",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "type": "Organisation",
      "abstractKey": null
    }
  ],
  "type": "HomeUnion",
  "abstractKey": "__isHomeUnion"
};
})();

(node as any).hash = "66c352c1bb64b56714c403cf6b420848";

export default node;
